import { useCallback, useEffect, useRef } from 'react';

import type { Rive } from '@rive-app/react-canvas';

const AUTO_ADVANCE_INTERVAL_MS = 5000;

interface UseAutoAdvanceOptions {
  rive: Rive | null;
  fireNext: () => void;
}

export function useAutoAdvance({ rive, fireNext }: UseAutoAdvanceOptions) {
  const intervalIdRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const clear = useCallback(() => {
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
      intervalIdRef.current = null;
    }
  }, []);

  const reset = useCallback(() => {
    if (!rive) return;
    clear();
    intervalIdRef.current = setInterval(fireNext, AUTO_ADVANCE_INTERVAL_MS);
  }, [rive, fireNext, clear]);

  useEffect(() => {
    if (!rive) return;
    reset();
    return clear;
  }, [rive, reset, clear]);

  useEffect(() => clear, [clear]);

  return { reset };
}
